export default "__VITE_ASSET__DqUrHJ5s__"